import { DepartmentApi } from '../../api/models/department-api';

export class Department
{
    departmentCode: string = '';
    departmentFR: string = '';

    public static mapperFromApi (mapperFromApi: DepartmentApi): Department
    {
        return Object.assign(new Department(), mapperFromApi);
    }
}